<script lang="ts">
  import { getContext } from 'svelte';
  import Play from '../../shared/assets/icons/Play.svelte';
  import IconButton from '../../shared/components/IconButton.svelte';
  import type { FocusItem, FocusLayer } from '../../shared/focus-manager/focus-types';
  import type { IconButtonSize } from '../../shared/types/icon-button';
  import type { PlayerStateContext } from '../../shared/types/player-state';
  import type { ContentLayerContext } from '../types/internal/content-layer';

  export let size: IconButtonSize = 'm';
  export let focusLayer: FocusLayer;
  export let focusName: FocusItem;

  const { startPlayer } = getContext<ContentLayerContext>('contentLayer');
  const { headline } = getContext<PlayerStateContext>('playerState');
</script>

<IconButton
  title="Wiedergabe"
  aria-label={$headline ? `Wiedergabe von ${$headline} starten` : 'Wiedergabe starten'}
  {...$$restProps}
  {size}
  {focusLayer}
  {focusName}
  on:click={startPlayer}
>
  <Play aria-hidden={true} />
</IconButton>
